import axios from "./axiosInstance";

const AiAPI = {
  getContent: (payload) => axios.post("ai/text-to-text", payload),
};

export default AiAPI;
